import React, { FC } from "react";
import { Div, Text } from "../../Kit";
import { Color } from "../../../StyleSheet";
import { separate } from "../../../Utils";

export type TokenDetailsItemProps = {
  title: string;
  value?: string | number;
  IconComponent?: FC;
  iconColor?: Color;
  lessThan?: boolean;
};

export const TokenDetailsItem: React.FC<TokenDetailsItemProps> = (props) => {
  const { title, value, lessThan } = props;
  return (
    <Div
      bg="secondary"
      className="h-[45px] w-full min-w-[228px] flex items-center justify-between rounded-[5px] px-[15px] mb-2"
    >
      <Text elementType="span" className="text-[14px]" fontWeight={400}>
        {title}
      </Text>
      <div className="flex items-center">
        {lessThan && (
          <Text
            elementType="span"
            fontWeight={300}
            color="text"
            className="text-[12px] me-[1px]"
            translatable={false}
          >
            ~
          </Text>
        )}
        {value?.toString() ? (
          <Text elementType="span" className="text-[16px] mx-1 mt-0.5" fontWeight={400}>
            {separate(value)}
          </Text>
        ) : null}
        <Text elementType="span" className="text-[10px]">
          toman
        </Text>
      </div>
    </Div>
  );
};
